import FormatCurrency from 'components/Common/FormatCurrency'
import Caption from 'LuxKit/Typography/Caption'
import type { ComponentProps } from 'react'
import { useIntl } from 'react-intl'

type InheritedFormatCurrencyProps = Pick<ComponentProps<typeof FormatCurrency>, 'signDisplay'>

interface Props extends InheritedFormatCurrencyProps {
  nonMemberPrice: number
  className?: string
}

/**
 * Displays price for non-members with a proper caption.
 */
function PriceRowLuxPlusNonMemberPrice(props: Props) {
  const {
    nonMemberPrice,
    signDisplay,
    className,
  } = props
  const intl = useIntl()
  const nonMemberPriceLabel = intl.formatMessage(
    {
      id: 'kDkl7bT4Gb-QmQ300neV',
      defaultMessage: 'Non-member {price}',
      description: 'Price caption label for non-member price display in the LuxPlus membership section',
    },
    {
      price: <b><FormatCurrency signDisplay={signDisplay} value={nonMemberPrice} format="roundedDollar" /></b>,
    },
  )

  return <Caption
    variant="medium"
    colour="light-foreground-alt"
    className={className}
  >
    {nonMemberPriceLabel}
  </Caption>
}

export default PriceRowLuxPlusNonMemberPrice
